import { render } from "./CarterProfile.vue?vue&type=template&id=67d739f0&scoped=true"
import script from "./CarterProfile.vue?vue&type=script&lang=js"
export * from "./CarterProfile.vue?vue&type=script&lang=js"

import "./CarterProfile.vue?vue&type=style&index=0&id=67d739f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d739f0"]])

export default __exports__